import { Button, Input, Modal, Select, Space } from "antd";
import { PlusOutlined, SettingOutlined } from "@ant-design/icons";
import createImagePromptGPT from "./controller/createImagePromptGPT";
import axios from "axios";
import { useEffect } from "react";
import dayjs from "dayjs";
import createImageGPT from "./controller/createImageGPT";
import s3Controller from "controllers/s3Controller";

const backend = process.env.REACT_APP_BACKEND

function ControlBox ({
    baseParams, 
    baseParamsHandler, 
    pos, 
    tableParams, 
    paginationHandler, 
    stateHandler,
    selectedRows, 
    prompt, 
    gptModel,
    dataChangeHandler,
    stopRef
  }) {

  const onSearch = (value) => {
    console.log(baseParams)
    baseParamsHandler({
      ...baseParams,
      search: value
    })
    paginationHandler(1, tableParams.pagination.pageSize)
  }

  const posFilter = (value) => {
    baseParamsHandler({
      ...baseParams,
      pos: value
    })
    paginationHandler(1, tableParams.pagination.pageSize)
  }

  const cefrOption = [
    {value: "A0", label: "A0"},
    {value: "A1", label: "A1"},
    {value: "A2", label: "A2"},
    {value: "B1", label: "B1"},
    {value: "B2", label: "B2"},
    {value: "C1", label: "C1"},
    {value: "C2", label: "C2"},
  ]
  const imageCountOption = [
    {value: 0, label: "0개"},
    {value: 1, label: "1개"},
    {value: 2, label: "2개"},
    {value: 3, label: "3개"},
    {value: 4, label: "4개"},
    {value: 5, label: "5개"},
    {value: 6, label: "6개"},
    {value: 7, label: "7개"},
    {value: 8, label: "8개"},
    {value: 9, label: "9개"},
    {value: 10, label: "10개"},
  ]
  const cefrLevelEvpFilter = (value) => {
    baseParamsHandler({
      ...baseParams,
      cefrLevelByEVP: value
    })
    paginationHandler(1, tableParams.pagination.pageSize)
  }
  const cefrLevelGptFilter = (value) => {
    baseParamsHandler({
      ...baseParams,
      cefrLevelByGPT: value
    })
    paginationHandler(1, tableParams.pagination.pageSize)
  }
  const imageCountFilter = (value) => {
    baseParamsHandler({
      ...baseParams,
      imageCount: value
    })
    paginationHandler(1, tableParams.pagination.pageSize)
  }

  const waitF = async (sec) => {
    return new Promise((resolve) => setTimeout(resolve, sec));
  }

  const checkWaitCondition = async (i, count) => {
    if(count === i) {
      console.log(`${count}개 완료 후 재요청 중`)
      return true
    }
  }

  //선택된 단어의 이미지프롬프트를 만드는 함수
  const createMeaningPromptAll = async () =>{
    const translatedSelectRows = selectedRows.filter(el=>el.translate_text)
    if(!translatedSelectRows.length) {
      Modal.error({
        title: "선택 에러",
        content: "프롬프트를 만들 수 있는 단어가 없습니다. 해석이 필요합니다.",
        okText:"확인",
      })
      return
    }

    let count=0
    stateHandler("loading",true)
    stateHandler("progressBar",[translatedSelectRows.length, count])
    loop:
    for (let i=0; i<translatedSelectRows.length; i++) {

      if(i !== 0 && i % 10 === 0) {
        let isContinue = false
        // console.log("일시정지", isContinue)
        while (!isContinue) {
          await waitF(1000)
          isContinue = await checkWaitCondition(i, count)
          
          //강제로 종료할 경우 루프를 종료시킨다. 이미 보낸 요청은 중지할 수 없다.
          if(stopRef.current === true) {
            stopRef.current = false
            stateHandler("progressBar",[0,0])
            stateHandler("loading",false)

            break loop
          }
        }
      }

      const record = translatedSelectRows[i]
      const meaningPrompt_1 = prompt.meaningPrompt.replace(/{word_en}/gi,record.word)
      const meaningPrompt = meaningPrompt_1.replace(/{word_ko}/gi,record.translate_text)
      
      createImagePromptGPT(meaningPrompt, gptModel.gpt_model)
      .then(newPrompt=>{
        let onlyPrompt = newPrompt
        if(newPrompt[0] === `"`) {
          onlyPrompt = newPrompt.slice(1,-1)
        }
        const value = {
          id: record.dalle_id,
          WordExMaster_id: record.id,
          meaning_prompt: onlyPrompt
        }
        axios.post(`${backend}/contents/new_word/image/meaning_prompt`,{value})
        .then(res=>{
          const instance = {...record}
          instance.meaning_prompt = onlyPrompt
          instance.dalle_id = res.data.data
          dataChangeHandler(instance, "meaning_prompt")
        })
        .catch(err=>{
          console.log(err)
          Modal.error({
            title:"에러",
            okText:"확인",
            content:"서버 에러가 발생해서 프롬프트를 생성하지 못했습니다."
          })
        })
      })
      .catch(err=>{
        console.log(err)
        Modal.error({
          title:"에러",
          okText:"확인",
          content:"AI 에러가 발생해서 프롬프트를 생성하지 못했습니다."
        })
      })
      .finally(()=>{
        count++
        if(count === translatedSelectRows.length) {
          stateHandler("loading",false)
          stateHandler("progressBar",[0,0])
        } else {
          stateHandler("progressBar", [translatedSelectRows.length, count])
        }
      })
    }
  }

  //선택된 단어의 배경프롬프트를 만드는 함수
  const createBackgroundPromptAll = async() =>{
    const translatedSelectRows = selectedRows.filter(el=>el.translate_text)
    if(!translatedSelectRows.length) {
      Modal.error({
        title: "선택 에러",
        content: "프롬프트를 만들 수 있는 단어가 없습니다. 해석이 필요합니다.",
        okText:"확인",
      })
      return
    }

    let count=0
    stateHandler("loading",true)
    stateHandler("progressBar",[translatedSelectRows.length, count])
    loop:
    for (let i=0; i<translatedSelectRows.length; i++) {

      if(i !== 0 && i % 10 === 0) {
        let isContinue = false
        while (!isContinue) {
          await waitF(1000)
          isContinue = await checkWaitCondition(i, count)
          
          //강제로 종료할 경우 루프를 종료시킨다. 이미 보낸 요청은 중지할 수 없다.
          if(stopRef.current === true) {
            stopRef.current = false
            stateHandler("progressBar",[0,0])
            stateHandler("loading",false)

            break loop
          }
        }
      }

      const record = translatedSelectRows[i]
      const backgroundPrompt = prompt.backgroundPrompt.replace(/{}|{ }/gi,record.word)
      
      createImagePromptGPT(backgroundPrompt, gptModel.gpt_model)
      .then(newPrompt=>{
        let onlyPrompt = newPrompt
        if(newPrompt[0] === `"`) {
          onlyPrompt = newPrompt.slice(1,-1)
        }
        const value = {
          id: record.dalle_id,
          WordExMaster_id: record.id,
          background_prompt: onlyPrompt
        }
        axios.post(`${backend}/contents/new_word/image/background_prompt`,{value})
        .then(res=>{
          const instance = {...record}
          instance.background_prompt = onlyPrompt
          instance.dalle_id = res.data.data
          dataChangeHandler(instance, "background_prompt")
        })
        .catch(err=>{
          console.log(err)
          Modal.error({
            title:"에러",
            okText:"확인",
            content:"서버 에러가 발생해서 프롬프트를 생성하지 못했습니다."
          })
        })
      })
      .catch(err=>{
        console.log(err)
        Modal.error({
          title:"에러",
          okText:"확인",
          content:"AI 에러가 발생해서 프롬프트를 생성하지 못했습니다."
        })
      })
      .finally(()=>{
        count++
        if(count === translatedSelectRows.length) {
          stateHandler("loading",false)
          stateHandler("progressBar",[0,0])
        } else {
          stateHandler("progressBar", [translatedSelectRows.length, count])
        }
      })
    }
  }

  // 이미지를 만드는 함수
  const createImageAll = async () =>{
    const filteredRows = selectedRows.filter(el=>el.final_prompt)
    if(!filteredRows.length) {
      Modal.error({
        title: "선택 에러",
        content: "이미지를 만들 수 있는 단어가 없습니다. 최종프롬프트 문장이 필요합니다.",
        okText:"확인",
      })
      return
    }

    let count=0
    stateHandler("loading",true)
    stateHandler("progressBar",[filteredRows.length, count])

    loop:
    for (let i=0; i<filteredRows.length; i++) {

      if(i !== 0 && i % 3 === 0) {
        let isContinue = false
        while (!isContinue) {
          await waitF(1000)
          isContinue = await checkWaitCondition(i, count)
          
          //강제로 종료할 경우 루프를 종료시킨다. 이미 보낸 요청은 중지할 수 없다.
          if(stopRef.current === true) {
            stopRef.current = false
            stateHandler("progressBar",[0,0])
            stateHandler("loading",false)

            break loop
          }
        }
      }

      const row = filteredRows[i]
      const prompt = row.final_prompt
      const currentVer = dayjs(new Date()).format("YYYYMMDDHHmmss");
      const fileName = `wordimage_${row.id}_${currentVer}.jpeg`;
      const size = gptModel.image_size

      createImageGPT(fileName, size,  prompt)
      .then(imageFile=>{
        if (imageFile === false) {
          count++
          // console.log("gpt에러", count)
          if(count === filteredRows.length) {
            stateHandler("progressBar",[0,0])
            stateHandler("loading",false)
          } else {
            stateHandler("progressBar",[filteredRows.length, count])
          }
        } else {
          s3Controller.s3Upload(imageFile,"word_image",(err, data)=>{
            //업로드가 완료되었을 경우 콜백
            if (err) {
              count++
              // console.log("aws에러", count)
              if(count === filteredRows.length) {
                stateHandler("progressBar",[0,0])
                stateHandler("loading",false)
              } else {
                stateHandler("progressBar",[filteredRows.length, count])
              }
            } else {
              const newKey = data.Key
              const newFile = data.Key.split("/")[1]
              axios.post(`${backend}/contents/new_word/image/new-image/${row.id}`,
              {newFile, size})
              .then(res=>{
                const instance = {...row}
                instance.image_count = instance.image_count + 1
                dataChangeHandler(instance, "image_count")
                count++
                // console.log("정상", count)
                if(count === filteredRows.length) {
                  stateHandler("progressBar",[0,0])
                  stateHandler("loading",false)
                } else {
                  stateHandler("progressBar",[filteredRows.length, count])
                }
              })
              .catch(err=>{
                console.log(err)
                s3Controller.s3DeleteFile(newKey, (err, data) => {
                  if (err) console.log(err);
                });
                count++
                // console.log("서버에러", count)
                if(count === filteredRows.length) {
                  stateHandler("progressBar",[0,0])
                  stateHandler("loading",false)
                } else {
                  stateHandler("progressBar",[filteredRows.length, count])
                }
              })
            }
          })
        }     
      })
      await waitF(1000)
    }
  }

  return (
    <Space wrap style={{justifyContent: "end"}}>
       <Input.Search
        placeholder="영어 문장을 입력하세요."
        onSearch={onSearch}
        allowClear={true}
        style={{
          width: 250,
          marginLeft: "5px",
        }}
      />
      <Select
        options={[{ value: "all", label: "품사: 전체" }, ...pos]}
        style={{ width: 150, textAlign: "left" }}
        defaultValue="all"
        value={baseParams.pos}
        onChange={posFilter}
      ></Select>
      <Select
        options={[{ value: "all", label: "CEFR 레벨(EVP): 전체" }, ...cefrOption]}
        style={{ width: 200, textAlign: "left" }}
        defaultValue="all"
        value={baseParams.cefrLevelByEVP}
        onChange={cefrLevelEvpFilter}
      ></Select>
      <Select
        options={[{ value: "all", label: "CEFR 레벨(GPT): 전체" }, ...cefrOption]}
        style={{ width: 200, textAlign: "left" }}
        defaultValue="all"
        value={baseParams.cefrLevelByGPT}
        onChange={cefrLevelGptFilter}
      ></Select>
      <Select
        options={[{ value: "all", label: "이미지 수: 전체" }, ...imageCountOption]}
        style={{ width: 200, textAlign: "left" }}
        defaultValue="all"
        value={baseParams.imageCount}
        onChange={imageCountFilter}
      ></Select>
      <Button onClick={()=>{stateHandler("settingModal",true)}}>
        <SettingOutlined />설정
      </Button>
      <Button disabled={!selectedRows.length} onClick={createMeaningPromptAll}>
        <PlusOutlined />주제 프롬프트 생성
      </Button>
      <Button disabled={!selectedRows.length} onClick={createBackgroundPromptAll}>
        <PlusOutlined />배경 프롬프트 생성
      </Button>
      <Button disabled={!selectedRows.length} onClick={createImageAll}>
        <PlusOutlined />이미지 생성
      </Button>
    </Space>
  )
}

export default ControlBox